import { AudioEngine } from "./AudioEngine";
import { AppView, worlds } from "@/constants";
import { LibraryAudioData } from '@audio/sceneData';
export class AudioTestApp {
    constructor() {
        this._view = AppView.LIBRARY;
        this.uiContainer = document.querySelector(".ui");
        this.uiContainer.addEventListener("click", this.handleButtonClick.bind(this));
        this.audioEngine = new AudioEngine();
    }
    handleButtonClick(event) {
        event.preventDefault();
        event.stopPropagation();
        const button = event.target;
        const { action, id, name } = button.dataset;
        switch (action) {
            case "world":
                this.selectWorld(id, name);
                break;
            case "scene":
                this.audioEngine.selectScene(parseInt(id));
                this.updateUI();
                break;
            case "gesture":
                const index = this.currentAudioData.gesture.samples.findIndex((sample) => sample.name === id);
                this.audioEngine.playGestureAudio(index);
                break;
        }
    }
    selectWorld(id, name) {
        let audioData;
        // Locate the correct world
        if (id === "library") {
            audioData = LibraryAudioData;
        }
        else {
            const portal = worlds.find((world) => world.name === id);
            audioData = portal.audioData;
        }
        // Load the relevant audio if found
        if (id && audioData) {
            this.audioEngine.loadAudioForWorld({
                name: id,
                audioData: audioData,
                autoPlay: true,
            });
        }
        this.currentAudioData = audioData;
        this.worldName = name;
        this.worldId = id;
        // Create scenes UI for this world
        this.createScenesUI();
        this.updateUI();
    }
    updateUI() {
        // Loop through all buttons and set the active state
        document.querySelectorAll("[data-action='world']").forEach((button) => {
            const id = button.dataset.id;
            const func = id === this.worldId ? "add" : "remove";
            button.classList[func]("active");
        });
        document.querySelectorAll("[data-action='scene']").forEach((button) => {
            const id = parseInt(button.dataset.id);
            const func = id === this.audioEngine.currentSceneIndex ? "add" : "remove";
            button.classList[func]("active");
        });
    }
    createScenesUI() {
        var _a, _b, _c;
        if (this.scenesUI) {
            this.scenesUI.remove();
        }
        if (this.gestureUI) {
            this.gestureUI.remove();
        }
        if (((_b = (_a = this.currentAudioData) === null || _a === void 0 ? void 0 : _a.scenes) === null || _b === void 0 ? void 0 : _b.length) > 1) {
            this.scenesUI = this.createUI("scenes");
        }
        if ((_c = this.currentAudioData) === null || _c === void 0 ? void 0 : _c.gesture) {
            this.gestureUI = this.createUI("gesture");
        }
    }
    createUI(type) {
        const title = type === "gesture" ? "Gestures" : "Scenes";
        const ui = document.createElement("div");
        ui.className = "ui-group";
        ui.innerHTML = `<h2>${title} for <em>${this.worldName}</em></h2>`;
        // Create the buttons
        let btnGroup;
        if (type === "gesture") {
            const { samples } = this.currentAudioData.gesture;
            const btns = samples.map((sample) => {
                const button = document.createElement("button");
                button.className = "btn";
                button.dataset.action = "gesture";
                button.dataset.id = sample.name;
                button.textContent = sample.name;
                return button;
            });
            btnGroup = this.createButtonGroup(btns);
        }
        else if (type === "scenes") {
            const { scenes } = this.currentAudioData;
            const btns = scenes.map((scene, index) => {
                const button = document.createElement("button");
                button.className = "btn";
                button.dataset.action = "scene";
                button.dataset.id = index.toString();
                button.textContent = scene.name;
                return button;
            });
            btnGroup = this.createButtonGroup(btns);
        }
        ui.appendChild(btnGroup);
        this.uiContainer.appendChild(ui);
        return ui;
    }
    createButtonGroup(buttons) {
        const group = document.createElement("div");
        group.className = "btn-group";
        buttons.forEach((button) => group.appendChild(button));
        return group;
    }
    previousStep() {
        if (this._view === AppView.WORLD && this.currentWorld) {
            const stepNow = this.currentWorld.previousStep();
            this.audioEngine.selectScene(stepNow);
        }
    }
    nextStep() {
        if (this._view === AppView.WORLD && this.currentWorld) {
            const stepNow = this.currentWorld.nextStep();
            this.audioEngine.selectScene(stepNow);
        }
    }
}
